import React from 'react';
import WifiIcon from '@mui/icons-material/Wifi';

const PingComponent = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <WifiIcon style={{ color: 'green', fontSize: 32 }} titleAccess="API connectée" />
    </div>
  );
};

export default PingComponent;
